import React from 'react'

export default ({ width = 100, height = 100 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <g id="battery_icon" transform="translate(-829 -600)">
        <g id="noun_batery_857470" transform="translate(861 693.572) rotate(-90)">
          <path id="Path_906" data-name="Path 906" d="M81.836,7.44c-.287,0-.56-.005-.817-.011q-.347-.008-.694-.009c-.184,0-.35.015-.519.028V7.44c0-4.476-3.64-7.44-8.116-7.44H8.116C3.64,0,0,2.964,0,7.44v20.29c0,4.476,3.64,8.792,8.116,8.792H71.691c4.476,0,8.116-4.316,8.116-8.792V26.37c.169.014.334.028.519.028.216,0,.448-.005.694-.009s.53-.012.817-.012c2.7,0,4.734-1.745,4.734-4.058V11.5C86.57,9.185,84.534,7.44,81.836,7.44ZM77.1,27.729c0,2.984-2.427,6.087-5.411,6.087H12.579L31.8,2.705H71.691c2.984,0,5.411,1.75,5.411,4.734Z" fill="#c1efe6"/>
        </g>
        <g id="Rectangle_1829" data-name="Rectangle 1829" transform="translate(829 600)" fill="none" stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="100" height="100" stroke="none"/>
          <rect x="0.5" y="0.5" width="99" height="99" fill="none"/>
        </g>
      </g>
    </svg>
  )
}